import { Tag } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalMessages from 'translations/messages';
import { DISTRIBUTION_METHODS } from 'shared/utils/distribution';

const methodMessage = method => globalMessages[method];

const SurveyDistributionTag = ({ methods }) => methods?.map(method => (
  methodMessage(method) ? (
    <Tag key={method}><FormattedMessage {...methodMessage(method)} /></Tag>
  ) : null
));

export const getDistributionMethodsColumn = () => ({
  dataIndex: 'distributionMethods',
  title: <FormattedMessage {...globalMessages.distribution} />,
  render: (methods) => <SurveyDistributionTag methods={methods} />,
  filters: DISTRIBUTION_METHODS.map(method => ({
    text: <FormattedMessage {...methodMessage(method)} />,
    value: method,
  })),
  onFilter: (value, record) => record.distributionMethods?.includes(value),
  sorter: (a, b) => {
    const aVal = a.distributionMethods?.join(',') || '';
    const bVal = b.distributionMethods?.join(',') || '';
    if (aVal && bVal) {
      return aVal.localeCompare(bVal, 'sv', { numeric: true });
    }
    if (aVal) {
      return 1;
    }
    if (bVal) {
      return -1;
    }
    return 0;
  },
  search: (methods, s) => methods?.some((method) => {
    const message = methodMessage(method);
    const label = message?.defaultMessage || message || '';
    return method.toLowerCase().search(s) !== -1 || String(label).toLowerCase().search(s) !== -1;
  }),
});

export default SurveyDistributionTag;
